import { MultiSelectProps } from '@healthnz-prm/fhir-engine-renderer/types'
import { InputFieldset } from '../inputFieldset'
import { Combobox, type ComboboxOption } from '@/components/ui/combobox'

export default function MultiSelect(props: MultiSelectProps) {
  const {
    inputId,
    label,
    onChange,
    options,
    value,
    onFocus,
    onBlur,
    required,
    disabled
  } = props

  const comboboxOptions: ComboboxOption[] = options.map(option => ({
    label: option.label,
    value: `${option.value}`,
    prefix: option.prefix
  }))

  return (
    <InputFieldset {...props}>
      <Combobox
        multiple
        options={comboboxOptions}
        value={(value ?? []).map(v => `${v}`)}
        onChange={values => onChange(values.map(v => Number.parseInt(v, 10)))}
        id={inputId}
        aria-label={label}
        required={required}
        disabled={disabled}
        onBlur={onBlur}
        onFocus={onFocus}
      />
    </InputFieldset>
  )
}
